import * as React from "react";
const SvgFiBrandsEtsy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M8.95 2.446c0-.326.034-.522.612-.522h7.778c1.358 0 2.106 1.109 2.649 3.196l.441 1.663h1.325c.239-4.729.443-6.783.443-6.783s-3.33.359-5.299.359H6.946L1.613.196v1.37l1.8.326c1.257.228 1.562.489 1.664 1.598 0 0 .102 3.261.102 8.641s-.102 8.609-.102 8.609c0 .978-.407 1.337-1.664 1.565l-1.8.325V24l5.334-.163h8.899c2.004 0 6.657.163 6.657.163.102-1.174.781-6.489.884-7.076h-1.258l-1.325 2.902c-1.053 2.283-2.581 2.446-4.28 2.446h-5.062c-1.697 0-2.513-.652-2.513-2.054v-7.435s3.77 0 4.993.098c.95.065 1.528.326 1.834 1.598l.407 1.696h1.46l-.101-4.272.204-4.304h-1.46l-.477 1.891c-.305 1.239-.509 1.467-1.834 1.598-1.732.163-5.027.13-5.027.13V2.446z"
    />
  </svg>
);
export default SvgFiBrandsEtsy;
